import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from 'src/app/services';

@Component({
  selector: 'app-process',
  templateUrl: './process.component.html',
  styleUrls: ['./process.component.scss']
})
export class ProcessComponent implements OnInit {
  constructor(public http: HttpService, public dialog: MatDialog, public router: Router, private route: ActivatedRoute,  ) { }

  ngOnInit(): void {  }
}
